import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SAVE_FILTERS, SAVE_FILTERS_SUCCESS, SAVE_FILTERS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';
import { GET_SIDEBAR_CONFIGURATION } from '../../../actionType.js';

function* saveFilters({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    // const { clientId, programId, userId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/saved-filters`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: SAVE_FILTERS_SUCCESS,
        payload: response?.data,
      });
      yield put({ type: GET_SIDEBAR_CONFIGURATION });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: SAVE_FILTERS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SAVE_FILTERS_ERROR, payload: error });
  }
}

export function* watchSaveFilters() {
  yield takeEvery(SAVE_FILTERS, saveFilters);
}

function* saveFiltersSaga() {
  yield all([fork(watchSaveFilters)]);
}

export default saveFiltersSaga;
